import { muiTheme } from '@tassat/payments-themes';

const muiStyles = (theme: typeof muiTheme) => ({
    flexColumn: {
        display: 'flex' as 'flex',
        flexFlow: 'column nowrap' as 'column nowrap',
        flexGrow: 1,
        alignItems: 'center' as 'center',
        marginTop: '2rem'
    },
    fieldContainer: {
        width: '100%',
        alignSelf: 'flex-start',
        backgroundColor: theme?.app?.applicationColors.backgroundPrimary || '#FFFFFF',
        padding: '1rem 2rem',
        marginBottom: '2rem'
    },
    withdrawalFieldContainer: {
        height: '100%',
        width: '100%',
        alignSelf: 'flex-start',
        backgroundColor: theme?.app?.applicationColors.backgroundPrimary || '#FFFFFF',
        padding: '1rem 2rem',
        marginBottom: '2rem'
    },
    fieldGroupHeader: {
        color: theme?.app?.clientTheme.colors.primaryColor || '#375073',
        fontSize: '1.5rem',
        marginBottom: '.75rem'
    },
    dollarPrefix: {
        alignSelf: 'center',
        fontSize: '2rem',
        paddingTop: '.5rem'
    },
    walletBankFirmNamesContainer: { marginBottom: '.5rem' },
    walletBankFirmNames: {
        fontSize: '0.875rem',
        lineHeight: 1
    },
    submitContainer: { marginTop: '4rem' },
    SelectAssetDropdownTitle: {
        color: '#375073',
        fontfamily: 'Corporate S',
        font: '1rem',
        fontstyle: 'normal',
        fontweight: 700,
        lineheight: '1.5rem',
        paddingBottom: '0.31rem'
    },
    AssetEquivalency: {
        color: '#000',
        fontfamily: 'Corporate S',
        font: '1rem',
        fontstyle: 'normal',
        fontweight: 700,
        lineheight: '1.5rem',
        paddingBottom: '0.31rem'
    },
    AvailableBalance: {
        color: 'var(--Background-Colors-Tassat-Black, #202020)',
        fontSize: '0.75rem',
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: 'normal'
    },
    withdrawalDataRow: {
        justifyContent: 'flex-start',
        alignItems: 'baseline',
        minWidth: '100%'
    },
    withdrawalTitle: {
        minWidth: '35%',
        color: 'var(--Background-Colors-Tassat-Black, #202020)',
        /* Body Extra Small */
        lineHeight: '1.5rem',
        marginRight: '30px',
        fontSize: '16px'
    },
    withdrawalData: {
        color: 'var(--Background-Colors-Tassat-Black, #202020)',
        /* Body Extra Small */
        lineHeight: 'normal',
        paddingBottom: '20px',
        fontSize: '16px'
    },
    copyButtonSmall: {
        cursor: 'pointer' as 'pointer',
        padding: '4px',
        marginLeft: '.4rem'
    },
    copyButtonIcon: {
        height: '14px',
        width: '14px'
    },
    instructionDetailsContainer: {
        maxHeight: '300px',
        overflowY: 'auto' as const
    }
});

export default muiStyles;